jQuery(document).ready(function () {

  const notifyMeVariants = window.cartSettings.notifyMeVariants;
  const cartItems = window.cartSettings.cartItems;

  let itemsChanging = [], changingProperties = [], refreshCart = false;
  if (cartItems.length > 0) {
    jQuery.each(cartItems, function (i, item) {
      const _estimated = jQuery(`.js-estimated-text[data-key="${item.key}"]`);
      const itemKey = item.key
      const itemClass = itemKey.replace(':', '')
      const maxAllowed = item?.properties?._limitedEditionMax ? item.properties._limitedEditionMax : ''
      let quantity = item.quantity

      jQuery(`.${itemClass} .quantity`).attr("data-max", '')

      if (maxAllowed != "" && quantity > maxAllowed) {
        let errorText = Shopify.theme.i18n.cart.exceededAmount
        errorText = errorText.replace('[sku]', item.title)
        errorText = errorText.replace('[qty]', maxAllowed)
        jQuery(`.${itemClass} > .cart-description > .row`).append(
          `<div class="cart-maximum-exceeded">
						<svg width="20" height="20" aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13">
							<circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/>
							<circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"/>
							<path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"/>
							<path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7">
						</svg>
						<div>${errorText}</div>
					</div>`)
        jQuery(`.${itemClass} .quantity`).attr("data-max", 'exceeded')
        jQuery('#cart-checkout-btn').attr("disabled", true)
        jQuery('#cart-checkout-btn').addClass("disabled")
      }

      if (_estimated) {
        changingProperties.push(_estimated.text());
      }
      if (notifyMeVariants.includes(item.key)) {
        quantity = 0
      }

      const changingItem = {
        id: item.id,
        quantity: quantity,
        properties: item.properties
      }

      itemsChanging.push(changingItem);
    });

    if (changingProperties.length > 0) {
      jQuery.each(changingProperties, function (i, item) {
        if (itemsChanging[i].properties._estimatedArrival !== undefined && itemsChanging[i].properties._estimatedArrival !== '' && itemsChanging[i].properties._estimatedArrival !== item) {
          itemsChanging[i].properties._estimatedArrival = item;
          refreshCart = true;
        }
      });
    }
  }

  if (refreshCart === true && itemsChanging.length > 0) {
    jQuery('#cart-checkout-btn').attr("disabled", true)
    jQuery.ajax({
      type: 'POST',
      url: '/cart/clear.js',
      dataType: 'json',
      success: function (data) {
        const dataItemsChanging = { 'items': itemsChanging.reverse() };
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: dataItemsChanging,
          dataType: 'json',
          success: function (data) {
            jQuery('#cart-checkout-btn').attr("disabled", false)
          },
          error: function (error) {
            console.log(error, "There's something wrong");
          }
        });
      },
      error: function (error) {
        console.log(error, "There's something wrong");
      }
    });
  }

  jQuery('#cart-checkout-btn').click(
    function (e) {
      if (notifyMeVariants != '') {
        e.preventDefault()
        const notifyMeArray = notifyMeVariants.split("|||")
        var notifyMeObject = {}
        jQuery.each(notifyMeArray, function (i, item) {
          if (item != '') {
            notifyMeObject[item] = 0
          }
        })
        jQuery.getJSON('/cart.js', function (cart) {
          const cartCount = cart.items.length
          let unavailableItemHTML = ''
          jQuery.each(cart.items, function (i, cartItem) {
            if (notifyMeArray.includes(cartItem.key)) {
              let cartItemOptions = ''
              jQuery.each(cartItem.options_with_values, function (i, itemOption) {
                const itemOptionHTML = `<div class="unavailable-popup__item-option"><b>${itemOption.name}:</b> ${itemOption.value}</div>`
                cartItemOptions += itemOptionHTML
              })
              unavailableItemHTML += `<div class="unavailable-popup__item"><div class="unavailable-popup__item-image"><img src="${cartItem.image}" width="150px"/></div><div class="unavailable-popup__item-content"><span class="unavailable-popup__item-title">${cartItem.product_title}</span><span>${cartItemOptions}</span></div></div>`
            }
          })
          let unavailableButtonHTML = `<div class="unavailable-popup__buttons"><button class="button unavailable-popup__continue js-remove-unavailable-items" data-unavailable-items=${JSON.stringify(notifyMeObject)} >${window.cartSettings.translations.unavailable_popup.buttonContinue}</button></div>`
          if (cartCount != Object.keys(notifyMeObject).length) {
            unavailableButtonHTML = `<div class="unavailable-popup__buttons"><button class="button unavailable-popup__continue js-remove-unavailable-items" data-unavailable-items=${JSON.stringify(notifyMeObject)}>${window.cartSettings.translations.unavailable_popup.buttonContinue}</button><button class="unavailable-popup__checkout button checkout-false js-remove-unavailable-items" data-unavailable-items=${JSON.stringify(notifyMeObject)}>${window.cartSettings.translations.unavailable_popup.buttonCheckout}</button><button class="hidden button checkout-true" type="submit" name="checkout" hidden>${window.cartSettings.translations.unavailable_popup.buttonCheckout}</button></div>`
          }
          const unavailableHTML = `<div class="unavailable-popup"><div class="unavailable-popup__wrapper"><div class="unavailable-popup__content"><h3 class="unavailable-popup__content-title">${window.cartSettings.translations.unavailable_popup.title}</h3><span class="unavailable-popup__content-text">${window.cartSettings.translations.unavailable_popup.content}</span></div><div class="unavailable-popup__items">${unavailableItemHTML}</div>${unavailableButtonHTML}</div></div>`
          document.getElementById('cart-checkout-btn').insertAdjacentHTML("afterend", unavailableHTML)

          jQuery('.js-remove-unavailable-items').click(function (e) {
            e.preventDefault()
            const buttonClicked = this
            const itemsToRemove = buttonClicked.dataset.unavailableItems
            const data = { updates: JSON.parse(itemsToRemove) }
            fetch('/cart/update.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(data)
            }).then(response => response.json())
              .then(data => redirectPage(data, buttonClicked))
              .catch((error) => console.error('Error', error))
          })

          function redirectPage(data, buttonClicked) {
            if (buttonClicked.classList.contains('checkout-false')) {
              document.querySelector('.checkout-true').click()
            } else {
              window.location.href = window.cartSettings.shopUrl + window.cartSettings.cartContinueRedirect;
            }
          }
        })

      }
    })



  let $removePopup = jQuery(`<div><div class="title">${window.cartSettings.translations.remove_popup.title}</div><div class="content">${window.cartSettings.translations.remove_popup.content}</div><div class="product-info"></div><div class="buttons"><div class="button white cancel">${window.cartSettings.translations.remove_popup.buttonCancel}</div><div class="button agree">${window.cartSettings.translations.remove_popup.buttonAgree}</div></div></div>`);
  jQuery('.cart-page .cart-actions .remove').featherlight($removePopup, {
    otherClose: '.button',
    variant: 'remove-popup',
    afterContent: function (e) {

      let removeHref = this.$currentTarget.attr('href'),
        pName = this.$currentTarget.data('product'),
        variantID = this.$currentTarget.data('variant-id');
      this.$content.addClass('variant-' + variantID).find('.product-info').html(pName);
      jQuery(document).on('click', '.featherlight-content .button.agree', function () {
        window.location.href = removeHref;
      });
    }
  });
});
